import { createContext } from 'react';
const ControllerContext = createContext(undefined);
export default ControllerContext;
//# sourceMappingURL=ControllerContext.js.map